import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { ActionSectionContent } from '~/src/features/payments-abn/styled';

export const Subtitle = styled.span`
    display: block;
    margin-top: 8px;
    ${FONTS.S};
    white-space: pre-wrap;

    & > span {
        ${FONTS.MediumS};
        color: ${COLORS.Link};
        cursor: pointer;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS};

        & > span {
            ${FONTS.MediumXS};
        }
    }
`;

export const Content = styled(ActionSectionContent)`
    row-gap: 16px;
`;

export const FrameHint = styled.div`
    max-width: 406px;
    ${FONTS.S};
    color: ${COLORS.TextDisabled};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS};
    }
`;


export const Container = styled.div<{ loading: boolean }>`
    width: 100%;
    height: ${props => props.loading ? '200px' : 'auto'};
    position: relative;
`;

export const Frame = styled.iframe`
    height: ${props => props.height || '630px'};
    width: 100%;
`;
